import React from 'react';
import EditTable from './../../common/EdiTable'
import AddFormModal from './../../common/AddFormModal'

class DataSources extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/settings/datasources',
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSRCID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label' : 'Enabled',
                        'source' : 'ATRSTATUS',
                        'type' : 'checkbox',
                        'editable' : true,
                        'default': true
                    },
                    {
                        'label': 'Name',
                        'source': 'ATRSRCNM',
                        'type': 'text',
                        'editable': true,
                        'default': '',
                        'placeholder': 'Name'
                    },
                    {
                        'label': 'NAS IP Address',
                        'source': 'ATRSRCIPADDR',
                        'type': 'text',
                        'editable': true,
                        'default': '',
                        'placeholder': '127.0.0.1'
                    },
                    {
                        'label': 'RADIUS Client IP',
                        'source': 'ATRCLIENTIPADDR',
                        'type': 'text',
                        'editable': true,
                        'default': '',
                        'placeholder': '127.0.0.1'
                    },
                    {
                        'label': 'Shared Secret',
                        'source': 'ATRSRCPASS',
                        'type': 'password',
                        'editable': true,
                        'default': '',
                        'placeholder': ''
                    },
                    {
                        'label' : 'Source Type',
                        'source': 'ATREQUIPID',
                        'type': 'select',
                        'editable': true,
                        'visible' : true,
                        'default' : 3
                    },
                    {
                        'label' : 'Parent Source',
                        'source' : 'ATRSRCPARID',
                        'type' : 'select',
                        'editable': true,
                        'visible' : true,
                        'default' : 0

                    },
                    {
                        'label' : 'Auth Types',
                        'source' : 'ATRAUTHTYPES',
                        'type' : 'multiple',
                        'editable' : true,
                        'default': '1,2,3',
                        'visible' : true
                    },
                    {
                        'label' : 'AcctUpdate',
                        'source' : 'ATRACCTUPDATE',
                        'type' : 'checkbox',
                        'editable' : true,
                        'default': true
                    },
                    {
                        'label' : 'Update Interval',
                        'source' : 'ATRUPDINTERVAL',
                        'type' : 'text',
                        'editable': true,
                        'visible' : true,
                        'default' : 120

                    },
                    {
                        'label' : 'Delete',
                        'type': 'button_delete'
                    }
                ]
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
 //       ajaxRequest(this.state.url, 'get',{}, this.ajaxSuccess);
    }

    ajaxSuccess(data) {
        this.setState({
            data: data
        });
    }
    onRowAdded(data) {
        var newdata = this.state.data;
        newdata.data.push(data);
        this.setState({data: newdata});
    }
    render(){
          return(
              <div className="col-lg-12">
                    <div className="row">
                        <div className="col-lg-8">
                            <h2>Data Sources</h2>
                        </div>
                        <div className="col-lg-4">
                            <AddFormModal
                                bsStyle="default"
                                addButton="true"
                                addButtonValue="Add Data Source"
                                metadata={this.state.metadata}
                                url={this.state.url}
                                remotemeta={this.state.data.metadata}
                                onRowAdded={this.onRowAdded.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <EditTable
                                data={this.state.data}
                                metadata={this.state.metadata}
                                url={this.state.url}
                            /></div>
                    </div>
              </div>
        )
    }
}
export default class extends React.Component{
    render(){
        return (<div>
            <DataSources />
        </div>)
    }
}